module.exports = __webpack_public_path__ + "img/logo.228dbe49.png";